<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-timeline>
      <a-timeline-item v-for="(browse,index) in browseList" :key="index" color="green">
        <p>{{ browse.createTime }}</p>
        <p>{{ browse.title }}</p>
      </a-timeline-item>
    </a-timeline>
  </a-drawer>
</template>

<script>
import { queryBrowseListById } from '@/api/biz/user'
export default {
  name: 'BrowseForm',
  data () {
    return {
      formTitle: null,
      open: false,
      browseList: []
    }
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    getList(id) {
      this.open = true
      this.formTitle = '行为记录'
      const param = { id: id }
      queryBrowseListById(param).then(response => {
        this.browseList = response.data
      })
    },
    onClose () {
      this.open = false
    }
  }
}

</script>

<style scoped>

</style>
